import React, { createContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { addSessionTime, isTokenValid } from 'src/util/auth'
import Swal from 'sweetalert2'

export const SessionContext = createContext(() => {
  throw Error('not Implemented')
})

const IdleSessionTimeout = ({ children }) => {
  const navigate = useNavigate()
  const intervalId = useRef()
  const handleSessionTimeout = () => {
    Swal.fire({
      icon: 'error',
      title: 'Session Timeout.',
      text: 'Please login again.',
      confirmButtonText: 'Login',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      if (intervalId.current) {
        clearInterval(intervalId.current)
      }
      sessionStorage.clear()
      navigate('/')
    })
  }
  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll']
    events.forEach((event) => {
      document.addEventListener(event, addSessionTime)
    })

    intervalId.current = setInterval(() => {
      if (!isTokenValid()) {
        Swal.fire({
          icon: 'warning',
          title: 'Session Timeout',
          text: 'Your session has expired. Please login again.',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/')
        })
      }
    }, 1000)

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, addSessionTime)
      })
      if (intervalId.current) {
        clearInterval(intervalId.current)
      }
    }
  }, [navigate])
  return <SessionContext.Provider value={handleSessionTimeout}>{children}</SessionContext.Provider>
}

IdleSessionTimeout.propTypes = {
  children: PropTypes.node.isRequired, // Ensure 'children' is passed and is of type 'node'
}
export default IdleSessionTimeout
